import { formatDate, numFormat, copyUrl, numFormat2, numberFormat } from "@/assets/js/mUtils";
import moment from "moment";
// 使用 require 兼容 CommonJS 规范的旧版 echarts 引入
const echarts = require("echarts");

export default function setupPrototype(Vue) {
    Vue.prototype.img_host = "https://mwphoto.oss-cn-shenzhen.aliyuncs.com/";
    Vue.prototype.formatDate = formatDate;
    Vue.prototype.numFormat = numFormat;
    Vue.prototype.numFormat2 = numFormat2;
    Vue.prototype.copyUrl = copyUrl;
    Vue.prototype.echarts = echarts;
    Vue.prototype.$moment = moment;
    Vue.prototype.numberFormat = numberFormat;
}
